// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 659 ? "object-storage" : chunkId) + "." + {"125":"6699d298","212":"c8d32604","278":"23391cc5","659":"6b622fc7","779":"30a6a1d0","868":"8912ec87"}[chunkId] + ".chunk.js";
};